export default function(offersElement) {
    const carousel = offersElement.querySelector('.offers__carousel');
    const jqueryCarousel = $(carousel);
    const modelNameCarousel = offersElement.querySelector('.offers__items');
    const jqueryModelNameCarousel = $(modelNameCarousel)

    jqueryModelNameCarousel.slick({
            arrows: true,
            dots: false,
            prevArrow: '<svg viewBox="0 0 134.258 404.258" class="offers__title-arrow offers__title-arrow--prev"><path fill="none" d="M-1-1h136.258v406.258H-1z"/><path d="M121.132332 46.561615l-14.627869-15.483742-92.396885 173.872971 92.396885 173.872955 14.627869-15.483734-84.16872-158.389221" id="prevArrowVans"/></svg>',
            nextArrow: '<svg viewBox="0 0 134.258 404.258"  class="offers__title-arrow offers__title-arrow--next"><path fill="none" d="M-1-1h136.258v406.258H-1z"/><path d="M14.10758194 363.34005736l14.627869 15.483742 92.396885-173.872971-92.396885-173.872955-14.627869 15.483734 84.16872 158.389221"/></svg> ',
            slidesToShow: 5,
            slidesToScroll: 5,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }
            ]
    });

    modelNameCarousel.querySelectorAll('.offers__item').forEach(modelTitle => {
        modelTitle.addEventListener('click', function() {
            modelNameCarousel.querySelectorAll('.offers__item').forEach(element => {
                element.classList.remove('offers__item--active');
            })
            this.classList.add('offers__item--active');

            // const carousel = $(this).parents('.container').find('.offers__carousel');
            jumpToSlide(jqueryCarousel, this.dataset.model);
        });
    });

    // const carousel = $('.offers__carousel');

    // carousel.on('init', function (slick, slider) {
    //     const e = $(slider.$slides.get(slider.currentSlide));

    //     $(this).parents('.container')
    //         .find('.offers__items li[data-model="'+e.data('model')+'"]')
    //         .addClass('offers__item--active');
    // });

    jqueryCarousel.on('init', function (event, slick) {
        const slide = slick.$slides[slick.slickCurrentSlide()];
        if (!slide) {
            return;
        }
        syncModelTitleSelectionWithOffer(slide);
    });

    jqueryCarousel.slick({
        arrows: true,
        prevArrow: '<svg viewBox="0 0 134.258 404.258" class="offers__arrow offers__arrow--prev"><path fill="none" d="M-1-1h136.258v406.258H-1z"/><path d="M121.132332 46.561615l-14.627869-15.483742-92.396885 173.872971 92.396885 173.872955 14.627869-15.483734-84.16872-158.389221" id="prevArrowVans"/></svg>',
        nextArrow: '<svg viewBox="0 0 134.258 404.258"  class="offers__arrow offers__arrow--next"><path fill="none" d="M-1-1h136.258v406.258H-1z"/><path d="M14.10758194 363.34005736l14.627869 15.483742 92.396885-173.872971-92.396885-173.872955-14.627869 15.483734 84.16872 158.389221"/></svg>',
    });

    function syncModelTitleSelectionWithOffer(slideElement) {
        const nextSlideDataElement = slideElement.querySelector('.offers__slide-data');
        if (!nextSlideDataElement) {
            return;
        }

        let model = nextSlideDataElement.dataset.model;
        modelNameCarousel.querySelectorAll('.offers__item').forEach(element => {
            if (model == element.dataset.model) {
                element.classList.add('offers__item--active');
                jumpToSlide(jqueryModelNameCarousel, model);
                return;
            }
            element.classList.remove('offers__item--active');
        })
    }

    jqueryCarousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        // const items = $(this).parents('.container').find('.offers__items');
        const nextSlideElement = slick.$slides[nextSlide];
        if (!nextSlideElement) {
            return;
        }
        syncModelTitleSelectionWithOffer(nextSlideElement);
    });

    function jumpToSlide(carousel, model) {
        const slide = carousel.find('[data-model="' + model + '"]').first();
        if (slide.length == 0) {
            return;
        }
        const slideContainer = slide.parents('.slick-slide').first();
        if (slideContainer.length == 0) {
            return;
        }
        carousel.slick('slickGoTo', slideContainer.data('slickIndex'), true);
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/fleet-and-business/modules/brand-index/vehicle-sliders.js